export default __webpack_public_path__ + "static/media/consulting.88fc6dc4.png";